import React from "react";
import { ProductReviewDetail, VariationOption } from "./reviewModels";
import { allVariations, filterReviews } from "./CustomerReviewHelper";
import ChildOrNull from "../ChildOrNull";
import { FilteredBy } from "./ReviewAggregationToolbar";
interface MultipleVariationFilterProps {
  onVariationTypeChange: (filteredReviewIds: number[], gtmLabel: string) => void;
  allProductReviews: readonly ProductReviewDetail[];
  variationOptions?: VariationOption[];
  filteredBy: FilteredBy;
  onVariationFilterChanged: (variation: Variation) => void;
}
export type Variation = {
  type: string | undefined;
  value: string | undefined;
};
const MultipleVariationFilter = ({
  onVariationTypeChange,
  allProductReviews,
  variationOptions = [],
  filteredBy,
  onVariationFilterChanged
}: MultipleVariationFilterProps) => {
  const variationTypeChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedOption = event.target.options[event.target.selectedIndex];
    const value = selectedOption?.value;
    const type = selectedOption?.closest("optgroup")?.label ?? variationOptions[0]?.type;
    const variation = {
      type,
      value
    };
    onVariationFilterChanged(variation);
    const filteredReviewIds = filterReviews([...allProductReviews], {
      variation,
      rating: filteredBy.rating
    }).map(review => review.reviewId);
    const variationValue = event.target.value;
    const gtmLabel = type ? `${type} - ${variationValue}` : variationValue;
    onVariationTypeChange(filteredReviewIds, gtmLabel);
  };
  const getFilterLabel = () => {
    let label = "Filter By";
    if (variationOptions) {
      const variationTypes = Array.from(new Set(variationOptions.map(option => option.type)));
      if (variationTypes.length === 1) {
        label += ` ${variationTypes[0]}`;
      }
    }
    return label;
  };
  const getVariationDropdownOptions = (variation: VariationOption) => {
    return variation.values.map(value => <option key={value} value={value}>
        {value}
      </option>);
  };
  const hasMultipleVariationTypes = () => {
    if (!variationOptions) {
      return false;
    }
    const variationTypes = Array.from(new Set(variationOptions.map(option => option.type)));
    return variationTypes.length > 1;
  };
  const shouldShowVariationDropdown = () => {
    return variationOptions && variationOptions?.length > 0 && variationOptions.flatMap(opt => opt.values).length > 1;
  };
  return <>
      <ChildOrNull condition={shouldShowVariationDropdown()} data-sentry-element="ChildOrNull" data-sentry-source-file="MultipleVariationFilter.tsx">
        <div className="float-left mr-0 mt-[7px] xs:mt-0">
          <label className="review-aggregation__label block" htmlFor="filterBy">
            {getFilterLabel()}
          </label>
          <select className="suffix_dropdown configure item_number text-sm w-[195px] xxxs:w-[155px] xxs:w-[165px] xsl:w-[195px]" id="filterBy" name="FilterBy" onChange={variationTypeChangeHandler} data-testid="review-filter-dropdown" value={filteredBy.variation.value}>
            <option value={allVariations}>All Options</option>
            {variationOptions.map(variation => <>
                <ChildOrNull condition={hasMultipleVariationTypes()}>
                  <optgroup label={variation.type} key={variation.type}>
                    {getVariationDropdownOptions(variation)}
                  </optgroup>
                </ChildOrNull>
                <ChildOrNull condition={!hasMultipleVariationTypes()}>
                  {getVariationDropdownOptions(variation)}
                </ChildOrNull>
              </>)}
          </select>
        </div>
      </ChildOrNull>
    </>;
};
export default MultipleVariationFilter;